<template>
<div class="chapter">
<div class="inner_page">
<h1 class="half"><a id="page_i"><b>A ROYAL NAVY COLD WAR BUCCANEER PILOT</b></a></h1><a id="page_i">
<p class="subtitle">FLYING THE FAMOUS MARITIME STRIKE AIRCRAFT</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Half.vue?2df04615